import { useContext, useEffect, useState } from "react";
import olMap from "ol/Map";
import olDrawInteraction from "ol/interaction/Draw";
import olVectorSource from "ol/source/Vector";

import { OLParser } from "../JSTS/OL";
import MapContext from "../map/MapContext";

export interface PolygonProps {
  source: olVectorSource;
  active: boolean;
  onDrawEnd?: (polygon: jsts.geom.Polygon) => void;
}

export const DrawPolygon = ({
  source,
  active,
  onDrawEnd: onDrawEnd,
}: PolygonProps) => {
  const [interaction, setInteraction] = useState<olDrawInteraction | null>(
    null
  );
  const map = useContext(MapContext) as olMap;

  useEffect(() => {
    if (!map) return () => {};

    const interaction = new olDrawInteraction({
      source,
      type: "Polygon",
    });
    interaction.setActive(active);
    interaction.on("drawend", (e) => {
      if (!onDrawEnd) return;
      const jstsGeom = OLParser.read(
        e.feature.getGeometry()
      ) as jsts.geom.Polygon;
      onDrawEnd(jstsGeom);
    });
    map.addInteraction(interaction);
    setInteraction(interaction);

    return () => {
      if (!map) return;
      map.removeInteraction(interaction);
      setInteraction(null);
    };
  }, [map, source, onDrawEnd]);

  useEffect(() => {
    if (!interaction) return;
    interaction.setActive(active);
  }, [active]);

  return null;
};
